import { Link } from "react-router-dom";

const links = [
    { to: "/", label: "Home", testId: "footer-home" },
    { to: "/#for-reps", label: "For Reps", testId: "footer-for-reps-link" },
    { to: "/for-surgeons", label: "For Surgeons", testId: "footer-for-surgeons" },
    { to: "/inducext", label: "InduceXT", testId: "footer-products" },
    { to: "/for-reps", label: "Schedule a Call", testId: "footer-for-reps" },
    { to: "/contact", label: "Contact", testId: "footer-contact" },
];

export default function Footer() {
    return (
        <footer data-testid="site-footer" className="bg-slate-50 border-t border-slate-200">
            <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
                    <div className="md:col-span-5">
                        <Link
                            to="/"
                            className="font-display text-xl font-semibold text-slate-900 flex items-center gap-2"
                        >
                            <span className="inline-block w-1.5 h-1.5 rounded-full bg-slate-900" />
                            1099er
                        </Link>
                        <p className="mt-4 text-sm text-slate-600 max-w-md leading-relaxed">
                            A private network of experienced orthopedic and biologics reps
                            matched with independent-line product opportunities.
                        </p>
                    </div>

                    <div className="md:col-span-3">
                        <p className="eyebrow mb-4">Navigation</p>
                        <ul className="space-y-3">
                            {links.map((l) => (
                                <li key={l.to}>
                                    <Link
                                        to={l.to}
                                        data-testid={l.testId}
                                        className="text-sm text-slate-600 hover:text-slate-900 transition-colors"
                                    >
                                        {l.label}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="md:col-span-4">
                        <p className="eyebrow mb-4">Important Disclaimer</p>
                        <p className="text-xs text-slate-500 leading-relaxed">
                            1099er is a connection platform. Reps are responsible for
                            reviewing employment agreements, hospital policies, credentialing
                            rules, non-compete and non-solicit obligations, compensation
                            arrangements, and any applicable compliance requirements before
                            entering a business relationship. 1099er does not provide legal,
                            employment, compliance, or medical advice.
                        </p>
                    </div>
                </div>

                <div className="mt-12 pt-8 border-t border-slate-200 flex flex-col md:flex-row justify-between gap-3">
                    <p className="text-xs text-slate-500">
                        © {new Date().getFullYear()} 1099er. All rights reserved.
                    </p>
                    <p className="text-xs text-slate-500">
                        Orthopedics · Biologics · Private by design
                    </p>
                </div>
            </div>
        </footer>
    );
}
